import { jwtDecode } from "jwt-decode";
import { useAuth } from "react-oidc-context";

export function useJwt() {
    const auth = useAuth();
    let jwt: any;

    jwt = jwtDecode(auth.user?.access_token ?? '', { header: false });

    return jwt;
}